var VIEWABLE_MIME_PREFIXES = ['image/'];
var VIEWABLE_MIME_TYPES = new Set(['application/pdf', 'text/plain', 'text/html']);
export function openEmlAttachment(attachment) {
    var _a;
    try {
        var binary = atob(attachment.base64);
        var bytes = new Uint8Array(binary.length);
        for (var i = 0; i < binary.length; i += 1) {
            bytes[i] = (_a = binary.codePointAt(i)) !== null && _a !== void 0 ? _a : 0;
        }
        var blob = new Blob([bytes], { type: attachment.mime || 'application/octet-stream' });
        var url_1 = URL.createObjectURL(blob);
        var isViewable = VIEWABLE_MIME_PREFIXES.some(function (prefix) { return attachment.mime.startsWith(prefix); })
            || VIEWABLE_MIME_TYPES.has(attachment.mime);
        if (isViewable) {
            window.open(url_1, '_blank');
        }
        else {
            var link = document.createElement('a');
            link.href = url_1;
            link.download = attachment.filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
        setTimeout(function () { return URL.revokeObjectURL(url_1); }, 30000);
    }
    catch (error) {
        console.error('Unable to open attachment', error);
    }
}
